<template>
  <div class="row">
    <div class="col-md-4 col-sm-12">
      <label>Typ kuwertury</label>
      <v-select label="name" :options="coatingCouvertures" v-model="couverture.couvertureType"
                @input="ChangeCouvertureType"></v-select>

      <div class="alert alert-danger" role="alert" v-if="!couverture.couverture">
        Wybierz kuwerturę
      </div>
    </div>
    <div class="col-md-5 col-sm-12">
      <label>Kuwertura</label>
      <v-select label="name" :options="couverturesOnShelf" v-model="couverture.couverture"></v-select>
      <div class="alert alert-danger" role="alert" v-if="!couverture.couverture">
        Wybierz kuwerturę
      </div>
    </div>

    <div class="col-md-2 col-sm-12">
      <label>Ilość kuwertury (kg)</label>
      <input type="number" class="form-control" step="0.001" v-model="weightSetter"/>

      <div class="alert alert-danger" role="alert" v-if="errors.weight">
        Wpisana waga przekracza wagę kuwertury lub jest nie prawidłowa
      </div>
    </div>
    <div class="col-md-1 col-sm-12 buttons-col-area">
      <button type="button" class="btn btn-primary button-col" @click="RemoveItem">
        Usuń
      </button>

    </div>
    <div class="col-sm-12 d-md-none">
      <Separator/>
    </div>
  </div>
</template>

<script>
import CouvertureMixins from '../../mixins/couverture'
import Separator from "@/common/Separator.vue";

export default {
  components: {Separator},
  props: ["couverture"],
  mixins: [CouvertureMixins],
  computed: {
    coatingCouvertures() {
      return this.$store.state.couvertureFormData.recipes;
    },
  },
  watch: {
    weightSetter(weight) {
      this.errors.weight = false;
      if (this.couverture.couverture) {
        if (weight > this.couverture.couverture.totalWeight || weight < 0) {
          this.errors.weight = true;
        }
        this.couverture.weight = parseFloat(weight);
      }
    },
    isValid() {
      this.isValid = !this.errors.weight && !this.errors.couverture;
    },
  },
  data() {
    return {
      couverturesOnShelf: undefined,
      weightSetter: 0,
      isValid: true,
      errors: {
        weight: false,
        couverture: false,
      },
    };
  },
  mounted() {
    var selectedCouvertureType = this.couverture.couvertureType;
    if (selectedCouvertureType) {
      this.GetCouverturesOnShelf(selectedCouvertureType.name);
    }
    if (this.couverture.weight) {
      this.weightSetter = this.couverture.weight;
    }
  },
  methods: {
    ChangeCouvertureType(selectedItem) {
      this.GetCouverturesOnShelf(selectedItem.name);
    },
    GetCouverturesOnShelf(name) {
      var that = this;
      if (name.length >= 2) {
        this.getCouverturesOnShelfByRecipeId(this.couverture.couvertureType.id, true)
            .then(function (res) {
              that.couverturesOnShelf = res.data;
            })
            .catch(function (e) {
              console.log(e);
            });
      }
    },
    RemoveItem() {
      this.$emit("AddExistingCouvertureRemoveItem", this.couverture.id);
    },
    changeItemOnList(item) {
      this.errors.couverture = !item;
    },
  },
};
</script>
